import { render, staticRenderFns } from "./BankSetting.vue?vue&type=template&id=c103e524&scoped=true&"
import script from "./BankSetting.vue?vue&type=script&lang=js&"
export * from "./BankSetting.vue?vue&type=script&lang=js&"
import style0 from "./BankSetting.vue?vue&type=style&index=0&id=c103e524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c103e524",
  null
  
)

export default component.exports